import styled from "styled-components";

import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

import Flexbox from "core/Flexbox";
import { regular as regularFontWeight } from "core/fontStyles";

export const CopyAttributionWidgetStyled = styled(Flexbox)`
    width: 100%;
    border-radius: ${convertPxToRem({ px: 3 })};
    border: solid ${convertPxToRem({ px: 1 })} ${colors.secondary.manatee};
    padding: ${convertPxToRem({ px: 16 })} ${convertPxToRem({ px: 12 })};
    ${regularFontWeight}
`;

export const CopyControlStyled = styled.div`
    flex: 0 0
        ${({ isDesktop }) =>
            isDesktop
                ? convertPxToRem({ px: 97 })
                : convertPxToRem({ px: 72 })};
`;
